export class AgrupamentoStringboxItem {
  idAgrupamento: number;
  idProduto: number;
  descricaoProduto: string;
  qtd: number;
}
